export default __webpack_public_path__ + "static/media/claim product 1024.331c0300.svg";